import { HStack, Image, Text, VStack } from "@chakra-ui/react";
import React from "react";

import australia from "../../../images/icons/australia.svg";
import bullseye from "../../../images/icons/bullseye.svg";
import taxOptimisation from "../../../images/icons/taxOptimisation.svg";

export const SignUpInfo = () => (
  <VStack
    backgroundColor="white"
    borderRadius="3xl"
    borderWidth="2px"
    borderColor="primary.200"
    width="full"
    maxWidth="30rem"
    p="2rem"
    fontSize="lg"
    spacing={10}
    shadow="md"
  >
    <HStack spacing={6}>
      <Image src={australia} alt="" boxSize={14} />
      <Text>
        Designed by{" "}
        <Text as="span" fontWeight="bold">
          Australian
        </Text>{" "}
        crypto tax professionals.
      </Text>
    </HStack>
    <HStack spacing={6}>
      <Image src={bullseye} alt="" boxSize={14} />
      <Text>
        <Text as="span" fontWeight="bold">
          Accurate
        </Text>{" "}
        tax classifications that meet ATO requirements.
      </Text>
    </HStack>
    <HStack spacing={6}>
      <Image src={taxOptimisation} alt="" boxSize={14} />
      <Text>
        Exclusive{" "}
        <Text as="span" fontWeight="bold">
          tax optimisation
        </Text>{" "}
        so you pay the lowest tax possible.
      </Text>
    </HStack>
  </VStack>
);
